import { Stack, Typography } from "@mui/material";
import { BankAccountPublicIDSelect } from "Components/Shared/Inputs/BankAccountPublicIDSelect";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import {
  type FieldValues,
  type FieldPath,
  type Control,
  Controller,
} from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  label?: string;
  control: Control<FormType, unknown, TransformedFieldValues>;
  disabled?: boolean;
  accounts: Array<BankAccountListItem>;
  isBalanceVisible?: boolean;
  isPrimaryChipHidden?: boolean;
  helperText?: string;
  emptyValueText?: string;
  onValueChange?: (value: string) => void;
};

export const BankAccountDropdown = <T extends object, V extends object>({
  control,
  name,
  label,
  disabled,
  accounts,
  isBalanceVisible,
  isPrimaryChipHidden,
  helperText,
  emptyValueText,
  onValueChange,
}: Props<T, V>) => (
  <Controller
    name={name}
    control={control}
    render={({
      field: { ref: _excludedRef, value, onChange, ...field }, //implement ref forwarding if needed
      fieldState: { error },
    }) => (
      <Stack>
        <Typography component="label" htmlFor={name} mb={1}>
          {label}
        </Typography>
        <BankAccountPublicIDSelect
          {...field}
          value={value || ""}
          onChange={(e) => {
            onChange(e);
            onValueChange?.(e.target.value as string);
          }}
          id={name}
          accounts={accounts}
          disabled={disabled}
          isBalanceVisible={isBalanceVisible}
          emptyValueText={emptyValueText}
          isPrimaryChipHidden={isPrimaryChipHidden}
          sx={{ mt: 1 }}
          error={!!error}
          helperText={error?.message || helperText}
        />
      </Stack>
    )}
  />
);
